import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/storage';
import 'firebase/auth';

import appConfig from 'application-config';
import { uploadMedia } from './upload-media';
import { deleteMedia } from './delete-media';

firebase.initializeApp(appConfig.firebaseConfig);

const db = firebase.firestore();
const auth = firebase.auth();

db.settings({});

export default {
	uploadMedia: uploadMedia(firebase),
	deleteMedia: deleteMedia(firebase),
	auth,
};
